import { useRouter } from 'next/router'

import Spinner from '@nxt-insurance/ui-kit/components/Spinner'
import Columns from '@nxt-insurance/ui-kit/components/layoutComponents/Columns'
import Section from '@nxt-insurance/ui-kit/components/layoutComponents/Section'
import Spacer from '@nxt-insurance/ui-kit/components/layoutComponents/Spacer'
import { h4 } from '@nxt-insurance/ui-kit/core/typography'

import { runQuery } from '@/cms/client'
import { productNavigationQuery } from '@/cms/productNavigationMenu'
import { ProductList } from '@/components/renderers/ProductList'
import { getLocaleParts } from '@/utils/locale'
import { useQuery } from '@tanstack/react-query'

export const ProductMenu = () => {
  const { locale } = useRouter()
  const [lang, market] = getLocaleParts(locale)
  const { data: productCategoriesData, isLoading } = useQuery({
    queryKey: ['productNavigationMenu', lang, market],
    queryFn: async () =>
      runQuery(productNavigationQuery, {
        lang,
        market,
      }),
    throwOnError: true,
  })
  if (isLoading) {
    return (
      <Section>
        <Spinner />
      </Section>
    )
  }

  if (!productCategoriesData) {
    return null
  }

  return (
    <div className="flex w-full flex-col items-center justify-center">
      <div className="flex w-full max-w-screen-2xl flex-col">
        <Section>
          <Columns className="justify-center" space="xxlarge" collapsable collapsedSpace="large">
            {productCategoriesData.productCategories.map((productCategory, index) => (
              <div
                className="flex flex-col"
                style={{ flex: 1 / productCategoriesData.productCategories.length }}
                key={productCategory._key}
              >
                <p className={h4()}>{productCategory.title}</p>
                <Spacer size="small" />
                <ProductList
                  node={{
                    index,
                    isInline: false,
                    renderNode: () => null,
                    value: { _type: 'productList', products: productCategory.products },
                  }}
                  sectionName="productMenu"
                />
              </div>
            ))}
          </Columns>
        </Section>
      </div>
    </div>
  )
}
